import '../style/Introduction.css';

function Introduction() {
  return (
    <div className="introduction-container" id="home">
      <h2 className="introduction-title-one">
        <span>Olá, Eu sou</span>
      </h2>
      <h1 className="introduction-title-two">
        <span>Frederico Tavares Pessoa</span>
      </h1>
      <h1 className="introduction-title-three">
        <span>Front-end Web Developer</span>
      </h1>
    </div>
  )
}

export default Introduction;
